import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function ShareUploadFromOtherapps() {
  const navigate = useNavigate();

  useEffect(() => {
    const formData = new FormData(document.forms[0]);
    const files = formData.getAll("photos");

    if (files.length) {
      window.sharedImages = files;

      navigate("/#/MyCar?share=true");
    }
  }, []);

  return (
    <h1 style={{ textAlign: "center", color: "red" }}>Preparing upload...</h1>
  );
}
